import Logo from './Logo';

interface BrandMarkProps {
  className?: string;
}

export default function BrandMark({ className = '' }: BrandMarkProps) {
  return <Logo variant="icon" iconClassName={`brand-mark rounded-full object-contain shadow-lg ${className}`} />;
}
